/**
 * Sort list records so recently created/updated items appear first.
 */
export const toSortTimestamp = (value) => {
  if (value == null || value === "") return 0;
  if (typeof value === "number") {
    return value < 1e12 ? value * 1000 : value;
  }
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const pickRecentTimestamp = (item = {}, fields = []) =>
  Math.max(0, ...fields.map((field) => toSortTimestamp(item?.[field])));

export const sortByRecent = (
  list = [],
  fields = [
    "createdAt",
    "creationDate",
    "createdDate",
    "createdOn",
    "updatedAt",
    "lastModifiedDate",
    "lastModified",
  ]
) => {
  const source = Array.isArray(list) ? list : [];
  if (source.length < 2) return [...source];

  const hasAnyDate = source.some(
    (item) => pickRecentTimestamp(item, fields) > 0
  );

  // If API returns chronological ascending without dates, reverse so newest is first.
  if (!hasAnyDate) {
    return [...source].reverse();
  }

  return [...source].sort((a, b) => {
    const diff =
      pickRecentTimestamp(b, fields) - pickRecentTimestamp(a, fields);
    if (diff) return diff;
    return 0;
  });
};
